var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66675 0.666748C1.56218 0.666748 0.666748 1.56218 0.666748 2.66675V18.6667C0.666748 19.7713 1.56218 20.6667 2.66675 20.6667H25.3334C26.438 20.6667 27.3334 19.7713 27.3334 18.6667V2.66675C27.3334 1.56218 26.438 0.666748 25.3334 0.666748H2.66675ZM12.0001 9.33342C12.0001 10.438 11.1047 11.3334 10.0001 11.3334C8.89551 11.3334 8.00008 10.438 8.00008 9.33342C8.00008 8.22885 8.89551 7.33341 10.0001 7.33341C11.1047 7.33341 12.0001 8.22885 12.0001 9.33342ZM22.0001 7.33341H16.6667V9.33341H22.0001V7.33341ZM22.0001 11.3334H16.6667V13.3334H22.0001V11.3334ZM12.7734 12.9067C11.9201 12.5334 10.9867 12.3334 10.0001 12.3334C9.01341 12.3334 8.08008 12.5334 7.22675 12.9067C6.48008 13.2267 6.00008 13.9467 6.00008 14.7601V15.3334H14.0001V14.7601C14.0001 13.9467 13.5201 13.2267 12.7734 12.9067Z",
    fill: "#B40F87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardIcon);
export default __webpack_public_path__ + "static/media/id-card-icon.c1633d8666efebf9d691ff439a5515a3.svg";
export { ForwardRef as ReactComponent };